import React from 'react';
import { Link } from 'react-router-dom';

const ComingSoon: React.FC = () => {
  return (
    <main style={{ 
      padding: '4rem 2rem', 
      backgroundColor: '#000000', 
      color: '#00ff00', 
      minHeight: 'calc(100vh - 80px)',
      fontFamily: 'monospace'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
        {/* Simple Terminal Header */}
        <div style={{ 
          backgroundColor: 'rgba(0, 0, 0, 0.9)', 
          border: '2px solid #00ff00', 
          borderRadius: '8px', 
          padding: '1.5rem',
          marginBottom: '3rem'
        }}>
          <div style={{ marginBottom: '1rem', color: '#66ffcc' }}>
            griffin@matrix:~$ status --store
          </div>
          <div style={{ color: '#ccffcc' }}>
            Status: COMING_SOON<br/>
            Progress: ████████░░ 80%<br/>
            Launch: Q2 2024
          </div>
        </div>

        {/* Main Title */}
        <h1 style={{ 
          fontSize: '3rem', 
          marginBottom: '1rem',
          background: 'linear-gradient(135deg, #00ff00, #66ffcc)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          Digital Arsenal
        </h1>
        
        <p style={{ 
          fontSize: '1.2rem', 
          color: '#66ffcc', 
          marginBottom: '3rem',
          lineHeight: '1.6'
        }}>
          Premium tools and applications are being forged in the digital realm.<br/>
          The ultimate collection of development tools is coming soon.
        </p>

        {/* Simple Feature List */}
        <div style={{ 
          marginBottom: '3rem',
          textAlign: 'left',
          display: 'inline-block'
        }}>
          <h2 style={{ color: '#00ff00', marginBottom: '1rem' }}>What's Coming:</h2>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '0.5rem' }}>🛠️ Professional Development Tools</li>
            <li style={{ marginBottom: '0.5rem' }}>🤖 AI-Powered Applications</li>
            <li style={{ marginBottom: '0.5rem' }}>⚡ Performance Optimization Utilities</li>
            <li style={{ marginBottom: '0.5rem' }}>🔒 Security-First Solutions</li>
          </ul>
        </div>

        {/* Navigation Test */}
        <div style={{ 
          marginBottom: '3rem', 
          padding: '1.5rem', 
          border: '1px solid #00ff00', 
          borderRadius: '8px',
          backgroundColor: 'rgba(0, 255, 0, 0.05)'
        }}>
          <p style={{ color: '#66ffcc', marginBottom: '1rem' }}>Navigation:</p>
          <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" style={{ color: '#00ff00', textDecoration: 'underline' }}>Home</Link>
            <Link to="/about" style={{ color: '#00ff00', textDecoration: 'underline' }}>About</Link>
            <Link to="/projects" style={{ color: '#00ff00', textDecoration: 'underline' }}>Projects</Link>
            <Link to="/articles" style={{ color: '#00ff00', textDecoration: 'underline' }}>Articles</Link>
            <Link to="/contact" style={{ color: '#00ff00', textDecoration: 'underline' }}>Contact</Link>
          </div>
        </div>

        {/* Simple CTA */}
        <div>
          <p style={{ marginBottom: '1rem', color: '#66ffcc' }}>
            Want updates? Follow development on GitHub.
          </p>
          <a
            href="https://github.com/GriffinCanCode"
            style={{
              display: 'inline-block',
              padding: '0.75rem 1.5rem',
              backgroundColor: '#00ff00',
              color: '#000000',
              textDecoration: 'none',
              borderRadius: '4px',
              fontWeight: 'bold'
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            FOLLOW DEVELOPMENT
          </a>
        </div>
      </div>
    </main>
  );
};

export default ComingSoon; 